import { FILTER_LABEL } from './types/filter.enums';
import { ASSETS_TYPE } from '@/types/shared/navigation-tabs.enums';
import { FiltersValues } from '@/components/uiKit/FiltersGroup/types';
import { Asset } from '@/types/shared/asset.types';
import { Fault } from '@/types/models/faults.types';
import { assetsFilterConfig } from './filter-config';
import { faultsFilterConfig } from './faults-filter-config';
import { getFiltersData, getFiltersValues, applyFilters } from '@/components/uiKit/FiltersGroup/utils';

export const getAssetsFiltersValues = (assets: Asset[], assetsCategory: string) => {
  const trimmedAssetsCategory =
    assetsCategory === ASSETS_TYPE.FIXED ? 'fixed' : assetsCategory === ASSETS_TYPE.MOBILE ? 'mobile' : 'all';

  const filteredAssets =
    trimmedAssetsCategory === 'all' ? assets : assets.filter((asset) => asset.asset_category === trimmedAssetsCategory);

  const { allFiltersValues, initialFiltersValues, currentFiltersValues } = getFiltersValues(
    filteredAssets,
    assetsFilterConfig
  );

  if (assetsCategory === ASSETS_TYPE.MOBILE) {
    delete allFiltersValues[FILTER_LABEL.CAMERA_INSTALLED];
    delete initialFiltersValues[FILTER_LABEL.CAMERA_INSTALLED];
    delete currentFiltersValues[FILTER_LABEL.CAMERA_INSTALLED];
  }

  return {
    allFiltersValues,
    initialFiltersValues,
    currentFiltersValues,
  };
};

export const getFilteredAssets = (
  assets: Asset[],
  currentFiltersValues: FiltersValues,
  assetsType: string
): Asset[] => {
  return assetsType === ASSETS_TYPE.MOBILE
    ? applyFilters(
        assets.filter((asset) => asset.asset_category === 'mobile'),
        assetsFilterConfig,
        currentFiltersValues
      )
    : assetsType === ASSETS_TYPE.FIXED
    ? applyFilters(
        assets.filter((asset) => asset.asset_category === 'fixed'),
        assetsFilterConfig,
        currentFiltersValues
      )
    : applyFilters(assets, assetsFilterConfig, currentFiltersValues);
};

export const getAssetsFiltersData = (
  assetsType: string,
  assets: Asset[],
  currentFiltersValues: FiltersValues,
  allFiltersValues: FiltersValues
) => {
  const filteredAssets = getFilteredAssets(assets, currentFiltersValues, assetsType);
  const assetsByAssetType =
    assetsType === ASSETS_TYPE.MOBILE
      ? assets.filter((asset) => asset.asset_category === 'mobile')
      : assetsType === ASSETS_TYPE.FIXED
      ? assets.filter((asset) => asset.asset_category === 'fixed')
      : assets;

  const assetsFiltersData = getFiltersData(
    assetsByAssetType,
    filteredAssets,
    assetsFilterConfig,
    currentFiltersValues,
    allFiltersValues
  );
  if (assetsType === ASSETS_TYPE.MOBILE) {
    return assetsFiltersData.filter((filter) => filter.filterLabel !== FILTER_LABEL.CAMERA_INSTALLED);
  } else {
    return assetsFiltersData;
  }
};

// Faults-specific filter functions
export const getFaultsFiltersValues = (faults: Fault[]) => {
  const { allFiltersValues, initialFiltersValues, currentFiltersValues } = getFiltersValues(faults, faultsFilterConfig);

  return {
    allFiltersValues,
    initialFiltersValues,
    currentFiltersValues,
  };
};

export const getFilteredFaults = (faults: Fault[], currentFiltersValues: FiltersValues): Fault[] => {
  return applyFilters(faults, faultsFilterConfig, currentFiltersValues);
};

export const getFaultsFiltersData = (
  faults: Fault[],
  currentFiltersValues: FiltersValues,
  allFiltersValues: FiltersValues
) => {
  const filteredFaults = getFilteredFaults(faults, currentFiltersValues);

  return getFiltersData(faults, filteredFaults, faultsFilterConfig, currentFiltersValues, allFiltersValues);
};
